export const ADVANCED_SEARCH_ENTITY_KEY = 'automations';
